// extracted by mini-css-extract-plugin
export default {"component":"item_component__Ws4p3","info":"item_info__I1JLA","title":"item_title__buxvx","description":"item_description__-pld8","arrow":"item_arrow__SfBd-"};